import { transient, autoinject, customElement } from "aurelia-framework";
import { NotificationClientService } from "../../../services/basics/notification-client.service";
import { Notification } from "./notification";

@autoinject()
@transient()
@customElement("rightship-notification")
export class RightshipNotification extends Notification {

    constructor(notificationService: NotificationClientService) {
        super(notificationService);
    }

}
